import { render, staticRenderFns } from "./AtomFormInputText.vue?vue&type=template&id=a22d6ae6&scoped=true&"
import script from "./AtomFormInputText.vue?vue&type=script&lang=js&"
export * from "./AtomFormInputText.vue?vue&type=script&lang=js&"
import style0 from "./AtomFormInputText.vue?vue&type=style&index=0&id=a22d6ae6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a22d6ae6",
  null
  
)

export default component.exports